export default __webpack_public_path__ + "static/steichen-2573dbb7b5b0c82dae20287b57d51575.jpg";